export { useIntersectionObserver } from './useIntersectionObserver'
export type { UseIntersectionObserverArgs } from './types'
